import accountsService from './accounts.service';
import authService from './auth.service';
import distributorsService from './distributors.service';
import documentsService from './documents.service';
import groupsService from './groups.service';
import importService from './import.service';
import intervenersService from './interveners.service';
import issuesService from './issues.service';
import operationsService from './operations.service';
import paymentsService from './payments.service';
import permissionService from './permission.service';
import pollsService from './polls.service';
import productsService from './products.service';
import subdistributorsService from './subdistributors.service';
import userActionsService from './userActions.service';
import usersService from './users.service';

const services = {
  $accountsService: accountsService,
  $authService: authService,
  $distributorsService: distributorsService,
  $documentsService: documentsService,
  $groupsService: groupsService,
  $importService: importService,
  $intervenersService: intervenersService,
  $issuesService: issuesService,
  $operationsService: operationsService,
  $paymentsService: paymentsService,
  $permissionService: permissionService,
  $pollsService: pollsService,
  $productsService: productsService,
  $subdistributorsService: subdistributorsService,
  $userActionsService: userActionsService,
  $usersService: usersService
};

export default services;
